import React, { useEffect, useRef } from "react";
import { useHistory, Route } from "react-router-dom";
import { connect } from "react-redux";
import { withRouter, useRouteMatch } from "react-router";
import { isMobile } from "react-device-detect";

import { ApplicationState } from "../../../store";
import {
  actionCreators,
  GalleryElement,
  GalleryState,
} from "../../../store/Gallery";

import { Dialog } from "@material-ui/core";
import Loading from "../../common/Loading";
import PopupGallery from "../PopupGallery";
import GalleryGrid from "../GalleryGrid";

import "../../styles/gallery.css";

type GalleryProps = GalleryState & typeof actionCreators;

const PATH = "/gallery/:parentId";

const Works: React.FC<GalleryProps> = (props) => {
  const history = useHistory();
  const sectionRef = useRef<HTMLElement | null>(null);

  const match = useRouteMatch<{ parentId: string }>(PATH);
  const parentId = Number(isMobile ? match?.params?.parentId ?? 0 : 0);

  const childElements = React.useMemo<GalleryElement[]>(() => {
    return props.galleryElements.filter((g) => g.parentId === parentId);
  }, [props.galleryElements, parentId]);

  useEffect(() => {
    if (!props.isLoaded) {
      props.requestGalleryElements();
    }
  }, [props.isLoaded]);

  const scrollToSection = () => {
    if (sectionRef.current) {
      window.scrollTo({
        top: sectionRef.current.offsetTop,
        behavior: "smooth",
      });
    }
  };

  return (
    <section ref={sectionRef} id="album" className="body-section">
      <div className="container">
        <h2 className="text-center section-title wow fadeIn">Works</h2>
        <hr />
      </div>
      <Route
        exact
        path={`${PATH}?`}
        children={({ match }: { match: any }): any =>
          !isMobile && (
            <Dialog
              maxWidth={false}
              onClose={() => {
                history.push("/");
              }}
              open={Boolean(match)}
              scroll="body"
            >
              <PopupGallery />
            </Dialog>
          )
        }
      />
      <Route
        path={[`${PATH}?`, "/"]}
        render={(routeProps) => {
          if (routeProps.history.action === "POP") {
            scrollToSection();
          }

          if (!props.isLoaded) {
            return (
              <Loading
                style={{
                  position: "relative",
                  zIndex: 0,
                  marginBottom: 70,
                  marginTop: 70,
                }}
              />
            );
          }

          return (
            <GalleryGrid
              containerClassName="gallery-grid"
              elements={childElements}
              onGalleryItemClick={(element: GalleryElement) => {
                if (element.parentId !== 0 && isMobile) {
                  return;
                }

                if (isMobile) {
                  scrollToSection();
                }

                history.push(PATH.replace(":parentId", String(element.id)));
              }}
              showOverlayOnGalleryElement={
                (isMobile && parentId === 0) || !isMobile
              }
              pageSize={9}
            />
          );
        }}
      />
    </section>
  );
};

export default connect(
  (state: ApplicationState) => state.gallery,
  actionCreators
)(withRouter(Works as any));
